import React, { Component } from 'react';
import './GraphicsIllustrate.css';
import ls from 'localstorage-slim';

import ApiLayersMap from '../../../modules/WebApiModules/ApiLayersMap';
import graphics from "./data/DATA.js";
import text from "./data/DESCRIPTION.js";
import example from './data/EXAMPLE.js';

const nameList = ["WMTS", "WMS", "I3S", "3DTiles"];
const theadList = {
    "WMTS": ["圖層名稱", "圖層介接代碼"],
    "WMS": ["圖層名稱", "圖層介接代碼"],
    "I3S": ["縣市", "建物服務代碼"],
    "3DTiles": ["縣市", "建物服務代碼"],
}

const tabText = ["規格", "範例"];
export class GraphicsIllustrate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            graphicTab: 0,
            childTab: 0,
            layerList: []
        };
        this.whiteList = [];
        this.whiteList.push("(社會經濟資料)");
    }

    componentDidMount() {
        let lsInfo = ls.get("userInfo", { decrypt: true });
        if (lsInfo) {
            let url = "https://ntmap.nantou.gov.tw/server/layer/get2DLayerList";
            //let url = "https://localhost:44352/OviewProxy?https://ntmap.nantou.gov.tw/server/layer/get2DLayerList";
            fetch(url, {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({})
            }).then((response) => {
                return response.json();
            }).then(function (json) {
                if (json.success) {
                    json.ret.forEach(layer => {
                        this.whiteList.push(layer.layername);
                    });

                    this.getLayerList();
                }
            }.bind(this)).catch((error) => {
                console.log(`Error: ${error}`);
            })
        }
        else {
            this.getLayerList();
        }
    }

    getLayerList() {
        ApiLayersMap.ListAll(
            // success
            (result) => {
                console.log(result);
                let list = [];
                this.getLayerListRecursive(list, result.result);

                this.setState({ layerList: list });
            },
            // error
            () => {
                console.error("取得圖層清單失敗");
            })
    }

    getLayerListRecursive(list, source) {
        source.forEach(layer => {
            if (layer.Class === "FOLDER") {
                this.getLayerListRecursive(list, layer.Layers);
            }
            else if (layer.Class !== "NOUSE" && this.checkWhiteList(layer.ID)) {
                if (!layer.FolderFullName.includes("三維圖資")) {
                    list.push({ name: layer.Name, ID: layer.ID });
                }
            }
        });
    }

    checkWhiteList(name) {
        if (this.whiteList) {
            for (let i = 0; i < this.whiteList.length; i++) {
                if (name.includes(this.whiteList[i])) {
                    return true;
                }
            }
        }

        return false;
    }

    tablePanel() {
        return (
            <table className="graphicsTableCol-table">
                <thead>
                    <tr className="graphicsTableCol-table-row">
                        {
                            theadList[nameList[this.state.graphicTab]].map(name => {
                                return (<th key={name}>{name}</th>);
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        this.tableContent()
                    }
                </tbody>
            </table>
        )
    }

    tableContent() {
        if (this.state.graphicTab === 0 || this.state.graphicTab === 1) {
            return (<>{
                this.state.layerList.map(info => {
                    return (
                        <tr key={info.name} className="graphicsTableCol-table-row">
                            <td>{info.name}</td>
                            <td>{info.ID}</td>
                        </tr>
                    );
                })}</>
            );
        }
        else {
            return (<>{
                graphics[nameList[this.state.graphicTab]].map(info => {
                    return (
                        <tr key={info[0] + "tr"} className="graphicsTableCol-table-row">
                            {
                                info.map(infodata => {
                                    return (<td key={infodata}>{infodata}</td>);
                                })
                            }
                        </tr>
                    );
                })}</>
            );
        }
    }

    content() {
        let context = "";
        switch (this.state.childTab) {
            case 0: context = text[nameList[this.state.graphicTab]];
                break;
            case 1: context = example[nameList[this.state.graphicTab]]; break;
            default: break;
        }

        return (
            <div className="graphicsInfoCol-content">
                <div className="graphicsInfoCol-content-tabside">
                    {
                        tabText.map((tab, index) => {
                            let className = this.state.childTab === index ? "graphicsInfoCol-content-tab tab-check" : "graphicsInfoCol-content-tab";
                            return (
                                <div key={tab} className={className} onClick={() => { this.setState({ childTab: index }) }}>
                                    {nameList[this.state.graphicTab] + tab}
                                </div>);
                        })
                    }
                </div>
                <div className="graphicsInfoCol-content-text">
                    {context}
                </div>
            </div>
        );
    }


    render() {
        return (
            <div className="graphicsIllustrate">
                <div className="graphicsInfoCol">
                    <div className="graphicsInfoCol-sidetop">
                        {
                            nameList.map((name, index) => {
                                return (
                                    <div key={name} className="graphicsInfoCol-sidetop-cell" onClick={() => { this.setState({ graphicTab: index, childTab: 0 }); }}>
                                        {name}
                                    </div>
                                );
                            })
                        }
                    </div>{
                        this.content()
                    }
                </div>
                <div className="graphicsTableCol">
                    {
                        this.tablePanel()
                    }
                </div>
            </div>
        );
    }
}